import {sinaClient, proxyClient, apiClient, decodeClient, appClient, accumulateClient, stockStatisticsClient} from './client'
import quotes from './quotes'
import install from './install'
import diagnosis from './diagnosis'

export default class Stock {
  constructor (options) {
    sinaClient.defaults.baseURL = options.sinaBaseURL
    proxyClient.defaults.baseURL = options.proxyBaseURL
    apiClient.defaults.baseURL = options.apiBaseURL
    decodeClient.defaults.baseURL = options.proxyBaseURL
    appClient.defaults.baseURL = options.appBaseURL
    accumulateClient.defaults.baseURL = options.accumulateBaseURL
    stockStatisticsClient.defaults.baseURL = options.stockStatisticsURL
    this.quotes = quotes
    this.diagnosis = diagnosis
  }
}

Stock.install = install



// WEBPACK FOOTER //
// ./src/plugins/stock/index.js